import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface InViewProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;

/** Reveals content once as it scrolls into view. */
export function InView({
  children,
  delay = 0,
  y = 16,
  className = ''
}: InViewProps) {
  const reduce = useReducedMotion();
  return <motion.div initial={reduce ? false : {
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    delay,
    duration: 0.3,
    ease: EASE
  }} className={className} data-id="element-38" data-mp="28onol008ho0f">
      {children}
    </motion.div>;
}